'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _functional = require('../utils/functional');

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PageFAQAccordion = function () {
  function PageFAQAccordion(el) {
    (0, _classCallCheck3.default)(this, PageFAQAccordion);

    var _this = this;

    this.accordions = (0, _functional.getElements)('[data-module-faq-accordion-item]', {
      context: el
    }).map(function (accordion) {
      return {
        els: {
          el: accordion,
          trigger: (0, _functional.getElement)('[data-module-faq-accordion-trigger]', {
            context: accordion
          }),
          body: (0, _functional.getElement)('[data-module-faq-accordion-body]', {
            context: accordion
          })
        },
        _isOpen: el.getAttribute('aria-expanded') === 'true',
        get isOpen() {
          return this.els.el.getAttribute('aria-expanded') === 'true';
        },

        set isOpen(val) {
          var _this2 = this;

          this._isOpen = val;
          if (val) {
            this.els.el.setAttribute('aria-expanded', String(val));
            (0, _utils.slideDown)(this.els.body, _this.getBodyHeight(this.els.body));
          } else {
            (0, _utils.slideUp)(this.els.body, _this.getBodyHeight(this.els.body)).then(function () {
              _this2.els.el.setAttribute('aria-expanded', String(val));
              _this2.els.body.removeAttribute('style');
            });
          }
        }
      };
    });

    this.setupListeners();
  }

  (0, _createClass3.default)(PageFAQAccordion, [{
    key: 'setupListeners',
    value: function setupListeners() {
      this.accordions.forEach(function (accordion) {
        accordion.els.trigger.addEventListener('click', function () {
          return accordion.isOpen = !accordion.isOpen;
        });
      });
    }
  }, {
    key: 'getBodyHeight',
    value: function getBodyHeight(el) {
      el.style.display = 'block';
      var style = window.getComputedStyle(el);
      var height = el.offsetHeight + (0, _functional.styleToNumber)(style.marginTop) + (0, _functional.styleToNumber)(style.marginBottom);
      el.style.display = '';

      return height;
    }
  }]);
  return PageFAQAccordion;
}();

exports.default = PageFAQAccordion;